import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getCanonicalStatus, OPTIONS, resolveNumeroSinistre } from './utils';
import { renumeroterSinistre, updateSinistre } from '../../../../../../hooks/useHooks';
import { Modal, Select, Typography } from 'antd';
import { useState } from 'react';

export const ChangeTypeModal = ({ sinistre, visible, onCancel, onSave, loading, setLoading, currentType }) => {
    const [selectedType, setSelectedType] = useState(currentType);
    const navigate = useNavigate();

    const handleConfirmChangeType = async () => {
        if (!selectedType) {
            toast.warning("Veuillez sélectionner un type de sinistre.");
            return;
        }

        if (selectedType === (sinistre?.typeSinistre || "")) {
            console.log("CT: ", selectedType, sinistre?.typeSinistre);
            toast.info("Le type sélectionné est identique à l'actuel.");
            onCancel();
            return;
        }

        const payload = { ...sinistre, typeSinistre: selectedType };
        try {
            setLoading(true);
            const response = await updateSinistre(payload);
            const updatePayload = response?.data || {};
            const effectiveCodeId = updatePayload?.codeId || sinistre?.codeId;
            let renumberSucceeded = true;
            let renumberPayload = null;

            const normalizeStatusValue = (value) =>
                (value || "")
                    .toString()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .trim()
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, "");

            const updatedCanonicalStatus = getCanonicalStatus(
                normalizeStatusValue(updatePayload?.sortDossier || sinistre?.sortDossier)
            );

            if (updatedCanonicalStatus === "O") {
                try {
                    const renumberResponse = await renumeroterSinistre(effectiveCodeId);
                    renumberPayload = renumberResponse?.data || null;
                } catch (renumberError) {
                    console.error(renumberError);
                    renumberSucceeded = false;
                    toast.warning("Type mis à jour mais la renumérotation a échoué.");
                }
            }

            // setEditTypeSinistre(selectedType);
            const mergedServerData = { ...sinistre, ...updatePayload, ...(renumberPayload || {}) };
            if (updatedCanonicalStatus !== "O") {
                mergedServerData.numeroSinistreM = null;
                mergedServerData.numeroSinistreP = null;
                mergedServerData.numeroSinistre = null;
                mergedServerData.numSinistre = null;
            }
            const finalNumero = resolveNumeroSinistre(mergedServerData);
            // if (onSinistreUpdate) {
            //     onSinistreUpdate((prev) => ({
            //         ...(prev || {}),
            //         ...mergedServerData,
            //         typeSinistre: currentType,
            //     }));
            // }
            if (updatedCanonicalStatus === "O") {
                toast.success(
                    renumberSucceeded
                        ? finalNumero && finalNumero !== "-"
                            ? `Type de sinistre mis à jour. Nouveau n° : ${finalNumero}`
                            : "Type de sinistre mis à jour avec succès."
                        : "Type de sinistre mis à jour."
                );
            } else {
                toast.success("Type de sinistre enregistré. Validez le dossier pour générer le numéro définitif.");
            }
            onCancel();
            navigate("/details-sinistre", { state: { codeId: effectiveCodeId }, replace: true });
        } catch (error) {
            console.error(error);
            toast.error("Erreur lors de la mise à jour du type de sinistre");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Changer le type de sinistre"
            open={visible}
            onCancel={onCancel}
            onOk={() => handleConfirmChangeType()}
            okText="Enregistrer"
            cancelText="Annuler"
            confirmLoading={loading}
        >
            <div style={{ marginBottom: 8 }}>
                <Typography.Text strong>Type de sinistre</Typography.Text>
            </div>
            <Select
                style={{ width: '100%' }}
                placeholder="Sélectionnez un type"
                options={OPTIONS.typeDommages}
                value={selectedType}
                onChange={setSelectedType}
            />
        </Modal>
    );
};

ChangeTypeModal.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    loading: PropTypes.bool,
    currentType: PropTypes.string,
    sinistre: PropTypes.object,
    setLoading: PropTypes.func
};
